import React, { useCallback } from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { Size, MessageDialog } from '@lux/dialog';
import { Notification as NotificationPermissionIcon } from '@lux/graphics';
import { TRACK_EVENTS } from '../types';
export function ReenableDialog({ isShown, data, onClose, onTrack }) {
    const closeDialog = useCallback(() => {
        onTrack(TRACK_EVENTS.NOTIFICATION_PUSH_BLOCKED_CLOSE, data);
        onClose(data);
    }, [data, onClose, onTrack]);
    return (React.createElement(TranslateScope, { path: "notificationReenableDialog" },
        React.createElement(MessageDialog, { isShown: isShown, size: Size.M, closeDialog: closeDialog, graphic: React.createElement(NotificationPermissionIcon, null), title: React.createElement(Translate, { message: "title" }), text: React.createElement(Translate, { message: "text" }), positiveButtonText: React.createElement(Translate, { message: "closeButton" }), positiveButtonProps: { onClick: closeDialog } })));
}
export default ReenableDialog;
//# sourceMappingURL=ReenableDialog.js.map